import React from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../../shared/components/Modal";

function VerificationModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    onClose();
    navigate("/login");
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="verificationModalContent">
        <h2>Verificá tu cuenta</h2>
        <p>
          Te enviamos un correo con un enlace para confirmar tu cuenta. Revisá
          tu bandeja de entrada (y también la carpeta de spam).
        </p>
        <button onClick={handleGoToLogin}>Ya verifiqué mi correo</button>
      </div>
    </Modal>
  );
}

export default VerificationModal;
